import { useState } from 'react';
import React from 'react';
import { useTouchPanZoom } from './useTouchPanZoom';

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;

export function useHexMapControls() {
  const [zoom, setZoom] = useState(2);
  const [panOffset, setPanOffset] = useState({ x: 0, y: 0 });
  const [isPanning, setIsPanning] = useState(false);
  const [panStart, setPanStart] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsPanning(true);
    setPanStart({ x: e.clientX - panOffset.x, y: e.clientY - panOffset.y });
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (isPanning) {
      setPanOffset({ x: e.clientX - panStart.x, y: e.clientY - panStart.y });
    }
  };

  const handleMouseUp = () => {
    setIsPanning(false);
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    if (e.deltaY < 0) {
      setZoom(prev => Math.min(MAX_ZOOM, prev + 0.5));
    } else {
      setZoom(prev => Math.max(MIN_ZOOM, prev - 0.5));
    }
  };

  // Touch: one-finger drag pans, two-finger pinch zooms, a clean tap falls through to the
  // browser's native click synthesis so hex tile selection keeps working untouched (GH-54).
  const { onTouchStart, onTouchMove, onTouchEnd } = useTouchPanZoom({
    panOffset, setPanOffset, zoom, setZoom, minZoom: MIN_ZOOM, maxZoom: MAX_ZOOM,
  });

  return {
    zoom, panOffset, isPanning,
    setZoom, setPanOffset,
    handleMouseDown, handleMouseMove, handleMouseUp, handleWheel,
    onTouchStart, onTouchMove, onTouchEnd,
  };
}
